
import { useState } from 'react';
import BookingChoiceModal from '../../../components/feature/BookingChoiceModal';

const CTA3Section = () => {
  const [showBookingChoice, setShowBookingChoice] = useState(false);

  return (
    <>
      <section className="py-20 bg-gradient-to-r from-[#24820C] via-[#2a9a0e] to-[#24820C]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-semibold mb-6">
            ⭐ Limited Time Offer
          </div>
          
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Transform Your Property Today
          </h2>
          <p className="text-xl text-green-100 mb-10 max-w-2xl mx-auto">
            Professional landscaping services with guaranteed quality. Get started in minutes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <i className="ri-file-list-3-line text-white text-3xl mb-3"></i>
              <h3 className="text-white font-semibold mb-2">Free Estimates</h3>
              <p className="text-green-100 text-sm">No obligation quotes for all services</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <i className="ri-time-line text-white text-3xl mb-3"></i>
              <h3 className="text-white font-semibold mb-2">Fast Response</h3>
              <p className="text-green-100 text-sm">Quick turnaround on all projects</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <i className="ri-shield-check-line text-white text-3xl mb-3"></i>
              <h3 className="text-white font-semibold mb-2">Quality Guaranteed</h3>
              <p className="text-green-100 text-sm">100% satisfaction on every job</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={() => setShowBookingChoice(true)}
              className="bg-white text-[#24820C] hover:bg-gray-100 font-bold py-5 px-10 rounded-full text-lg transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Book Now
            </button>
            
            <a 
              href="#"
              className="call-trigger inline-block"
              data-phone="4438191521"
            >
              <button className="border-2 border-white text-white hover:bg-white hover:text-[#24820C] font-bold py-5 px-10 rounded-full text-lg transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2"></i>
                Call (443) 819-1521
              </button>
            </a>
          </div>
        </div>
      </section>

      <BookingChoiceModal isOpen={showBookingChoice} onClose={() => setShowBookingChoice(false)} />
    </>
  );
};

export default CTA3Section;
